import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "v-col-6 v-col-md-3" }
const _hoisted_3 = { class: "p-2" }
const _hoisted_4 = {
  key: 0,
  class: "p-2"
}
const _hoisted_5 = {
  key: 1,
  class: "p-2"
}
const _hoisted_6 = {
  key: 2,
  class: "p-2"
}
const _hoisted_7 = {
  key: 3,
  class: "p-2"
}

import Api from '@/services/api'
    import { onBeforeMount } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElIcon, ElInput, ElMessage, ElMessageBox, ElRow } from 'element-plus';
    import { useStore } from 'vuex';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { Product } from '@/services/types/product';
import { defaultPaginated } from '@/utilities/helpers';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductsView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Product>>(defaultPaginated)
    const q = ref<string>('')
    const searchType = ref<'string' | 'number'>('string')
    const cod = ref<number>()

    const getProducts = async (q = '', page = 1) => {
        console.log("Okay")
        loading.value = true
        const res = await Api.get(`admin/products?q=${q}&page=${page}`)
        if (res.status == 200) {
            data.value = res.data.products
            console.log(res.data.products)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
        }
        loading.value = false
    }
    
    const getProduct = async (id: number | undefined) => {
        if (!id || id <= 0) {
            getProducts()
        } else {
            loading.value = true
            data.value.last_page = 1
            data.value.current_page = 1
            const res = await Api.get('admin/products/' + id)
            if (res.status == 200) {
                data.value.data = [res.data.product]
            } else {
                ElMessageBox.alert('Não foi encontrado nenhum produto com este código')
                data.value.data = []
            }
            loading.value = false
        }
    }

    const changePage = (page: number) => {
        getProducts(q.value, page)
    }

    const featured = async (row: any) => {
        row.loading = true
        const res = await Api.put(`admin/featured/product/${row.id}`, {})
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.featured = !row.featured
        }
        row.loading = false
    }

    onBeforeMount(() => {
        getProducts()
    })

    const store = useStore()
    store.watch((state, getter) => getter.openModal, async (val, oldVal) => {
        if (oldVal == 2) {
            // new product
            await getProducts()
        }
    })

    const active = async (row: any) => {
        row.loading = true
        const res = await Api.delete(`admin/products/${row.id}`)
        if (res.status != 200) {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message ? res.data.message:''})
        } else {
            ElMessage.success({message: row.name + ' Actualizado com sucesso'})
            row.active = !row.active
        }
        row.loading = false
    }

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Search = _resolveComponent("Search")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Produtos cadastrados" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElRow), { class: "py-2" }, {
          default: _withCtx(() => [
            _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "v-col-6 v-col-md-9 me-3" }, "Pesquisar", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_radio_group, {
                modelValue: searchType.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchType).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "string",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("por nome", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "number",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Pelo codigo", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        (searchType.value == 'string')
          ? (_openBlock(), _createBlock(_unref(ElRow), {
              key: 0,
              class: "pb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "search",
                  name: "q",
                  style: {"flex":"1"},
                  modelValue: q.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((q).value = $event)),
                  class: "mx-1",
                  placeholder: "Procurar produtos"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ElButton), {
                  loading: loading.value,
                  onClick: _cache[2] || (_cache[2] = () => getProducts(q.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(ElRow), {
              key: 1,
              class: "pb-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElInput), {
                  type: "number",
                  name: "cod",
                  modelValue: cod.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((cod).value = $event)),
                  style: {"flex":"1"},
                  class: "mx-1",
                  placeholder: "Digite o codigo do produto"
                }, null, 8, ["modelValue"]),
                _createVNode(_unref(ElButton), {
                  disabled: cod.value ? false:true,
                  loading: loading.value,
                  onClick: _cache[4] || (_cache[4] = () => getProduct(cod.value))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElIcon), null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Search)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })),
        _createVNode(PaginatedTable, {
          loading: loading.value,
          page: data.value.current_page,
          "show-rows": 10,
          pages: data.value.last_page,
          data: data.value.data,
          cols: [
                {label: 'Cod', prop: 'id'},
                {label: 'Nome', prop: 'name'},
                {label: 'Preço', prop: 'price'},
                {label: 'Promocao', prop: 'promoction'},
                {label: 'Activo', prop: 'active'},
            ],
          onChange: changePage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    tag: "router-link",
                    to: '/products/' + data.row.id,
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["to"])
                ]),
                (data.row.active)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createVNode(_unref(ElButton), {
                        loading: data.row.loading,
                        onClick: () => active(data.row),
                        type: "warning",
                        icon: "RemoveFilled",
                        title: "Desativar"
                      }, null, 8, ["loading", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createVNode(_unref(ElButton), {
                        loading: data.row.loading,
                        onClick: () => active(data.row),
                        type: "success",
                        title: "Activavar",
                        icon: "Select"
                      }, null, 8, ["loading", "onClick"])
                    ])),
                (!data.row.featured)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                      _createVNode(_unref(ElButton), {
                        loading: data.row.loading,
                        onClick: () => featured(data.row),
                        type: "success",
                        title: "Destacar",
                        icon: "Upload"
                      }, null, 8, ["loading", "onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createVNode(_unref(ElButton), {
                        loading: data.row.loading,
                        onClick: () => featured(data.row),
                        type: "warning",
                        title: "Despromover",
                        icon: "Download"
                      }, null, 8, ["loading", "onClick"])
                    ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "page", "pages", "data"])
      ]),
      _: 1
    })
  ]))
}
}

})